import { mapGetters } from 'vuex';
import routerNames from '@/const/routerConstants';

export default {
  data: () => ({}),
  computed: {
    ...mapGetters('ELA', ['GET_GNT_CD', 'GET_GNT_GUBUN_CD', 'GET_CLOSE_DAY']),
  },
  methods: {
    toSelectDate() {
      // 취소신청일때는 이동 불가
      if (this.isReward || this.isCancelReward) return false;
      this.$router.push(routerNames.StartDate);
    },
    toGntGubunMenu() {
      // 취소신청일때는 이동 불가
      if (this.isReward || this.isCancelReward) return false;
      this.$router.push(routerNames.GntGubunMenu);
    },
    pushChips(className, chipName, routeName) {
      this.chips.push({ className, chipName, routeName });
    },
  },
};
